import BuddyList from './BuddyList';

export default BuddyList;
